import React, { useRef, useState } from 'react'
import * as THREE from 'three'
import { TextureLoader, ObjectSpaceNormalMap } from 'three'
import { useFrame, useLoader } from '@react-three/fiber'

const Box = (props) => {
    // This reference will give us direct access to the mesh
    const mesh = useRef()
    const texture = useLoader(TextureLoader, 'textures/aerial_rocks_02_diff_4k.jpg')
    const roughnessMap = useLoader(TextureLoader, 'textures/aerial_rocks_02_rough_4k.jpg')

    // Set up state for the hovered and active state
    const [hovered, setHover] = useState(false)
    const [active, setActive] = useState(false)
    // Rotate mesh every frame, this is outside of React without overhead
    useFrame(state => (
      mesh.current.rotation.y = mesh.current.rotation.y += 0.00001,
      mesh.current.rotation.x = mesh.current.rotation.y += 0.001
    ))
  
    return (
      <mesh
        {...props}
        ref={mesh}
        scale={hovered ? 1.01 : 1}
        onClick={(event) => setActive(!active)}
        onPointerOver={(event) => setHover(true)}
        onPointerOut={(event) => setHover(false)}>
        <sphereGeometry
            attach="geometry"
            args={[10, 200, 200]}
            widthSegments={100}
        />
        {/* <meshPhysicalMaterial {...materialProps} attach="material"/> */}
        <meshStandardMaterial
            attach="material"
            roughness={.7}
            reflectivity={.4}
            metalness={0}
            map={texture}
            roughnessMap={roughnessMap}
        />
      </mesh>
    )
  }

export default Box